import { Injectable } from "@angular/core";
import { AlertMessageOptions, AlertMessageService } from '@serpro/ngx-dsgovbr';


@Injectable({
  providedIn: 'root'
})
export class MensagemService {

  autoClose = false;
  botaoFechar = true;

  constructor(private alertMessageService: AlertMessageService) { }

  limpar() {
    this.alertMessageService.dismissAll();
  }

  mostrar(tipo: string, titulo: string, mensagem: string): void {
    this.limpar();
    const options: AlertMessageOptions = {
      delay: this.autoClose ? 5000 : undefined,
      dismissible: this.botaoFechar,
    };

    if (tipo == 'Sucesso') {
      this.alertMessageService.success(
        titulo,
        mensagem,
        [],
        options,
        'xxxyyy'
      );
    } else if (tipo == 'Aviso') {
      this.alertMessageService.warn(
        titulo,
        mensagem,
        [],
        options,
        'xxxyyy'
      );
    } else if (tipo == 'Erro') {
      this.alertMessageService.error(
        titulo,
        mensagem,
        [],
        options,
        'xxxyyy'
      );
    } else if (tipo == 'Alvo') {
      this.alertMessageService.success(
        titulo,
        mensagem,
        [],
        options,
        'xxxyyy'
      );
    }

    this.scrollToTop();
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

}
